export const ORDERS_BASE_URL = '/v2/orders';

export const PENDING_ORDERS_URL = `${ORDERS_BASE_URL}/pending`;
export const FETCH_TOTAL_ORDERS = `${ORDERS_BASE_URL}/total`;
export const EXPORT_ORDERS = `${ORDERS_BASE_URL}/export`;
export const FETCH_ORDERS_FILTERS = `${ORDERS_BASE_URL}/filters`;
export const ORDERS_BOUNCED_EMAILS_URL = `${ORDERS_BASE_URL}/:id/bounced-emails`;
export const FETCH_MULTIPLE_COUNTS_ORDERS = `${ORDERS_BASE_URL}/counts`;
